<template>
  <div class="container">
    <img class="testimonial-img" src="@/assets/images/andy.jpg" alt="An image of Andy Donachie. Managing Director of Sans Souci Consulting Ltd">

    <div>
      <p class="testimonial-quote">

        <img class="quote-start" src="@/assets/quote-start.svg" alt="An image of an start quotation mark">
        JAW have been fantastic to work with.
        <img class="quote-end" src="@/assets/quote-end.svg" alt="An image of an end quotation mark">
      </p>
      <p class="testimonial"> Andy Donachie, Managing Director - Sans Souci Consulting Ltd </p>
    </div>

  </div>

</template>

<script setup>


</script>

<style scoped>
.container {
  width: 100%;
  height: 363px;
  background-color: #070923;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.testimonial-img {
  width: 143px;
  height: 143px;
  margin-top: 35px;
  border-radius: 90%;
}

.testimonial-quote {
  width: 287px;
  color: white;
  font-size: 25px;
  font-family: Oxanium-SemiBold;
  text-align: center;
}

.testimonial {
  width: 305px;
  color: #00FFBA;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
}

.quote-wrapper {
  display: inline-flex;
  justify-content: center;
}

.quote-start {
  height: 50px;
  width: 50px;
  margin-right: -10px
}

.quote-end {
  height: 50px;
  width: 50px;
  position: absolute;
  margin-top: 5px;
  margin-left: -15px;
}

@media (min-width: 640px) {

}

/* md: ≥ 768px - Tablets / landscape phones */
@media (min-width: 768px) {

}

/* lg: ≥ 1024px - Small laptops */
@media (min-width: 1024px) {
  .container {
    height: 450px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .testimonial-img {
    width: 326px;
    height: 326px;
    border-radius: 90%;
  }

  .testimonial-quote {
    width: 950px;
    font-size: 50px;
  }

  .testimonial {
    width: 850px;
    font-size: 24px;
  }

  .quote-start {
    height: 100px;
    width: 100px;
    margin-right: -30px
  }

  .quote-end {
    height: 100px;
    width: 100px;
    margin-left: -35px;
  }
}

/* xl: ≥ 1280px - Desktops */
@media (min-width: 1280px) {

}

/* 2xl: ≥ 1536px - Large screens / 4K monitors */
@media (min-width: 1536px) {
  .container {
    height: 450px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .testimonial-img {
    width: 326px;
    height: 326px;
    border-radius: 90%;
  }

  .testimonial-quote {
    width: 1105px;
    font-size: 50px;
  }

  .testimonial {
    width: 1044px;
    font-size: 24px;
  }

    .quote-start {
    height: 100px;
    width: 100px;
    margin-right: -30px
  }

  .quote-end {
    height: 100px;
    width: 100px;
    margin-left: -35px;
    margin-top: 60px;
  }
}

</style>